module.exports = __webpack_public_path__ + "img/concretehatchet.09ed6096.png";